var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9155 2.58439C14.7011 2.37083 14.4464 2.20188 14.1663 2.0873C13.8861 1.97272 13.5861 1.91478 13.2834 1.91683C12.9807 1.91888 12.6815 1.98088 12.4029 2.09924C12.1244 2.2176 11.872 2.38998 11.6604 2.60642L2.5311 11.7358L1.41669 16.0832L5.76415 14.9682L14.8935 5.83884C15.11 5.62738 15.2824 5.37509 15.4008 5.09658C15.5192 4.81806 15.5813 4.51884 15.5833 4.21621C15.5853 3.91358 15.5274 3.61354 15.4128 3.33345C15.2982 3.05336 15.1292 2.79876 14.9155 2.58439V2.58439Z",
    stroke: "#5E5E5E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3998 2.86771L14.6322 6.10013",
    stroke: "#5E5E5E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.53174 11.7351L5.76731 14.965",
    stroke: "#5E5E5E",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.8d81c1d70fc268bde854cf36a0ffd8e8.svg";
export { ForwardRef as ReactComponent };